export default __webpack_public_path__ + "static/media/AI Template Tutorial.e96bbe5b.mp4";